import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Editor, HANDLED, NOT_HANDLED } from 'medium-draft';
import customrenderer from '../../../components/MediumDraft/customrenderer';
import s from './LessonTextContent.scss';

const LessonTextContent = React.forwardRef(
  (
    {
      editorState,
      editorEnabled,
      onEditorChange,
      handleKeyCommand,
      keyBinding,
      handleReturn,
      inlineButtons,
      isTextExist,
      fullWidth,
      className,
      onContentScroll,
      onSelect,
      onEditorDoubleClick,
      fullSize,
      children,
    },
    ref,
  ) => (
    <div
      className={classNames(s.lessonTextContent, className, {
        [s.fullWidth]: fullWidth,
        [s.noContent]: !isTextExist,
        [s.fullSize]: fullSize,
      })}
      // onTouchStart={this.onDoubleTap} // to disable edit toolbar on IOS
      onScroll={onContentScroll}
      onSelect={onSelect}
      id="lesson-content"
      onDoubleClick={onEditorDoubleClick}
    >
      {isTextExist && (
        <Editor
          ref={ref}
          showLinkEditToolbar={false}
          editorState={editorState}
          editorEnabled={editorEnabled}
          onChange={onEditorChange}
          handleKeyCommand={handleKeyCommand}
          keyBindingFn={keyBinding}
          handleReturn={handleReturn}
          handleDrop={() => HANDLED}
          sideButtons={[]}
          blockButtons={[]}
          inlineButtons={inlineButtons}
          rendererFn={customrenderer}
          spellCheck={false}
        />
      )}
      {children}
    </div>
  ),
);

LessonTextContent.propTypes = {
  editorState: PropTypes.object, // eslint-disable-line
  editorEnabled: PropTypes.bool,
  onEditorChange: PropTypes.func,
  handleKeyCommand: PropTypes.func,
  keyBinding: PropTypes.func.isRequired,
  handleReturn: PropTypes.func,
  inlineButtons: PropTypes.array, // eslint-disable-line
  isTextExist: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string.isRequired,
  onContentScroll: PropTypes.func,
  onSelect: PropTypes.func,
  onEditorDoubleClick: PropTypes.func,
  fullSize: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

LessonTextContent.defaultProps = {
  editorEnabled: false,
  onEditorChange: _.noop,
  handleKeyCommand: () => false,
  keyBindingFn: () => 'do-nothing', // eslint-disable-line
  handleReturn: () => NOT_HANDLED,
  inlineButtons: [],
  isTextExist: false,
  fullWidth: false,
  onContentScroll: _.noop,
  onSelect: _.noop,
  onEditorDoubleClick: _.noop,
  fullSize: false,
};

export default withStyles(s)(LessonTextContent);
